interface RawEnvironment {
  readonly VITE_API_BASE_URL?: string;
}

/** Configuration validée au démarrage : une URL d'API invalide échoue tôt et clairement. */
export class AppConfig {
  readonly apiBaseUrl: string | null;

  private constructor(apiBaseUrl: string | null) {
    this.apiBaseUrl = apiBaseUrl;
  }

  static fromEnvironment(env: RawEnvironment): AppConfig {
    const raw = env.VITE_API_BASE_URL?.trim() ?? '';
    if (raw === '') return new AppConfig(null);

    const url = new URL(raw);
    if (url.protocol !== 'https:' && url.hostname !== 'localhost') {
      throw new Error(`VITE_API_BASE_URL doit être en HTTPS (reçu : ${raw})`);
    }
    return new AppConfig(url.toString().replace(/\/+$/, ''));
  }
}
